import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { getSearchNavPath } from '@/shared/lib/navigation';

import { TRole } from '@/shared/types/role';

/**
 * Состояние глобального поиска + переход по submit.
 * Роль передаётся параметром, чтобы хук оставался в shared (FSD).
 * @param role Роль пользователя
 */
export const useGlobalSearch = (role: TRole) => {
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  /**
   * Переход на страницу поиска по текущему значению
   */
  const onSubmit = () => {
    navigate(getSearchNavPath(role, searchValue));
  };

  return { searchValue, setSearchValue, onSubmit };
};
